// import { getCurrentUser } from 'helpers/Utils';
// import { isAuthGuardActive, currentUser } from 'constants/defaultValues';

import {
  GET_LAYERS,
  GET_LAYERS_ERROR,
  GET_LAYERS_SUCCESS,
  CREATE_LAYER,
  CREATE_LAYER_ERROR,
  CREATE_LAYER_SUCCESS,
  UPDATE_LAYER,
  UPDATE_LAYER_ERROR,
  UPDATE_LAYER_SUCCESS,
  DELETE_LAYER,
  DELETE_LAYER_ERROR,
  DELETE_LAYER_SUCCESS,
  SET_CREATING_LAYER,
  Messages,
  SET_CURRENT_LAYER,
  SET_CURRENT_TRAIT,
  SET_CREATING_TRAIT,
  CREATE_TRAIT_SUCCESS,
  CREATE_TRAIT_ERROR,
  UPDATE_TRAIT,
  UPDATE_TRAIT_SUCCESS,
  UPDATE_TRAIT_ERROR,
  DELETE_TRAIT,
  DELETE_TRAIT_SUCCESS,
  DELETE_TRAIT_ERROR,
  UPDATE_LAYER_LIST,
  UPDATE_LAYER_LIST_SUCCESS,
  UPDATE_LAYER_LIST_ERROR,
  SET_ORDER_LAYER_MODAL,
} from '../contants';

const INIT_STATE = {
  status: 'init',
  loading: false,
  savinglist: false,
  savinglistmessage: Messages.empty(),
  orderModal: false,
  list: [],
  current: null,
  traitId: null,
  creatingTrait: false,
  creating: false, // this can hold {...layer, loading, message:{type:false|string,text:string}}
  editing: false, // this can hold {...layer, loading, message:{type:false|string,text:string}}
  deleting: false, // this can hold {...layer, loading, message:{type:false|string,text:string}}
  message: Messages.empty(),
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CREATING_TRAIT:
      return { ...state, creatingTrait: action.payload };
    case CREATE_TRAIT_SUCCESS: {
      const trait = action.payload;
      const lyrs = [...state.list];
      for (let i = 0; i < lyrs.length; i += 1) {
        if (lyrs[i].id === trait.layerId) lyrs[i].traits.push(trait);
      }
      return {
        ...state,
        list: lyrs,
      };
    }
    case CREATE_TRAIT_ERROR:
      return {
        ...state,
        creatingTrait: {
          ...state.creatingTrait,
          message: { type: 'error', text: action.payload },
        },
      };
    case GET_LAYERS:
      return { ...state, loading: true, message: Messages.empty() };
    case GET_LAYERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        list: action.payload,
        message: Messages.success('layers loaded!'),
        status: 'loaded',
        current: null,
        traitId: null,
      };
    }
    case GET_LAYERS_ERROR: {
      return {
        ...state,
        loading: false,
        list: [],
        status: 'error',
        message: Messages.error(action.payload),
        current: null,
        traitId: null,
      };
    }

    case SET_CREATING_LAYER: {
      return { ...state, creating: action.payload };
    }

    case CREATE_LAYER: {
      return {
        ...state,
        creating: {
          ...state.creating,
          message: Messages.empty(),
          loading: true,
        },
      };
    }
    case CREATE_LAYER_SUCCESS: {
      const lyrs = [...state.list];
      lyrs.push(action.payload);
      return {
        ...state,
        list: lyrs,
        creating: false,
      };
    }
    case CREATE_LAYER_ERROR: {
      const { creating } = state;
      return {
        ...state,
        creating: {
          ...creating,
          loading: false,
          message: Messages.error(action.payload),
        },
      };
    }

    // Updating layer
    case UPDATE_LAYER: {
      const lyrs = [...state.list];
      return {
        ...state,
        list: lyrs.map((v) => {
          return v.id === action.payload.id
            ? { ...v, loading: true }
            : { ...v };
        }),
      };
    }
    case UPDATE_LAYER_SUCCESS: {
      const lyrs = [...state.list];
      return {
        ...state,
        list: lyrs.map((v) => {
          return v.id === action.payload.id
            ? { ...v, ...action.payload, loading: false }
            : { ...v };
        }),
        editing: false,
      };
    }
    case UPDATE_LAYER_ERROR: {
      const lyrs = [...state.list];
      const { editing } = state;
      return {
        ...state,
        list: lyrs.map((v) => {
          return v.id === editing.id ? { ...v, loading: false } : { ...v };
        }),
        editing: {
          ...editing,
          loading: false,
          message: Messages.error(action.payload),
        },
      };
    }

    // Updating layers order
    case SET_ORDER_LAYER_MODAL:
      return { ...state, orderModal: action.payload };
    case UPDATE_LAYER_LIST: {
      return {
        ...state,
        savinglist: true,
        savinglistmessage: Messages.info('please wait ..'),
      };
    }
    case UPDATE_LAYER_LIST_SUCCESS: {
      const lyrs = [...state.list];
      const updated = lyrs.map((v) => {
        const lyr = action.payload.find((x) => x.data.id === v.id);
        return lyr ? { ...v, ...lyr.data, loading: false } : { ...v };
      });
      return {
        ...state,
        list: updated,
        savinglist: false,
        savinglistmessage: Messages.success('layers order updated!'),
      };
    }
    case UPDATE_LAYER_LIST_ERROR: {
      return {
        ...state,
        savinglist: false,
        savinglistmessage: Messages.error(action.payload),
      };
    }

    // Updating Trait
    case UPDATE_TRAIT: {
      const lyrs = [...state.list];
      return {
        ...state,
        list: lyrs.map((v) => {
          return v.id === action.payload.layerId
            ? {
                ...v,
                traits: v.traits.map((t) => {
                  return t.id === action.payload.id
                    ? { ...t, loading: true }
                    : { ...t };
                }),
              }
            : { ...v };
        }),
      };
    }
    case UPDATE_TRAIT_SUCCESS: {
      const lyrs = [...state.list];

      return {
        ...state,
        list: lyrs.map((v) => {
          return v.id === action.payload.layerId
            ? {
                ...v,
                traits: v.traits.map((t) => {
                  return t.id === action.payload.id
                    ? {
                        ...t,
                        ...action.payload,
                        loading: false,
                      }
                    : { ...t };
                }),
              }
            : { ...v };
        }),
      };
    }
    case UPDATE_TRAIT_ERROR: {
      const lyrs = [...state.list];
      return {
        ...state,
        list: lyrs.map((v) => {
          return v.id === action.payload.layerId
            ? {
                ...v,
                traits: v.traits.map((t) => {
                  return t.id === action.payload.id
                    ? {
                        ...t,
                        loading: false,
                      }
                    : { ...t };
                }),
              }
            : { ...v };
        }),
      };
    }

    // Deleting Layer
    case DELETE_LAYER: {
      const lyrs = [...state.list];
      return {
        ...state,
        list: lyrs.map((v) => {
          return v.id === action.payload.id
            ? { ...v, loading: true }
            : { ...v };
        }),
      };
    }
    case DELETE_LAYER_SUCCESS: {
      const lyrs = [...state.list];
      return {
        ...state,
        list: lyrs.filter((v) => v.id !== action.payload.id),
        deleting: false,
      };
    }
    case DELETE_LAYER_ERROR: {
      const lyrs = [...state.list];
      return {
        ...state,
        list: lyrs.map((v) => {
          return v.id === action.payload.id
            ? { ...v, loading: false }
            : { ...v };
        }),
      };
    }

    // Deleting Trait
    case DELETE_TRAIT: {
      const lyrs = [...state.list];
      return {
        ...state,
        list: lyrs.map((v) => {
          return v.id === action.payload.layerId
            ? {
                ...v,
                traits: v.traits.map((t) => {
                  return t.id === action.payload.id
                    ? { ...t, loading: true }
                    : { ...t };
                }),
              }
            : { ...v };
        }),
      };
    }
    case DELETE_TRAIT_SUCCESS: {
      const lyrs = [...state.list];
      return {
        ...state,
        list: lyrs.map((v) => {
          return v.id === action.payload.layerId
            ? {
                ...v,
                traits: v.traits.filter((t) => t.id !== action.payload.id),
              }
            : { ...v };
        }),
      };
    }
    case DELETE_TRAIT_ERROR: {
      const lyrs = [...state.list];
      return {
        ...state,
        list: lyrs.map((v) => {
          return v.id === action.payload.layerId
            ? {
                ...v,
                traits: v.traits.map((t) => {
                  return t.id === action.payload.id
                    ? {
                        ...t,
                        loading: false,
                      }
                    : { ...t };
                }),
              }
            : { ...v };
        }),
      };
    }

    // Others
    case SET_CURRENT_LAYER:
      return {
        ...state,
        current: action.payload,
        traitId: null,
      };
    case SET_CURRENT_TRAIT:
      return {
        ...state,
        traitId: action.payload,
      };
    default:
      return { ...state };
  }
};
